<template>

    <v-card>
        <v-card-title>Disregarded Alarms</v-card-title>

        <v-divider />

        <v-card-text>

            <alarms-list :alarms="$props.alarms" :alarmGridResources="$props.alarmGridResources" eid="ag-grid-disregarded-alarms-container" />

        </v-card-text>

        <v-divider />

        <v-card-actions>
            <div class="flex-grow-1"></div>
            <v-btn text @click="$emit('close')">Close</v-btn>
        </v-card-actions>

    </v-card>
    
</template>

<script>
import AlarmsList from "@/components/Alarms/AlarmsList";
export default {
    name: 'DisregardedAlarmsList',
    props: ['alarms', 'alarmGridResources'],
    components: {
        AlarmsList
    },
    data: () => ({

    }),

    computed: {

    },

    methods: {
    },

    mounted() {
    }

  
};
</script>

<style>

    #ag-grid-disregarded-alarms-container {
        height: calc(80vh - 85px);
        max-height: calc(80vh - 85px);
        margin-top: 10px;
    }

    #ag-grid-disregarded-alarms-container .ag-row-hover {
        /* putting in !important so it overrides the theme's styling as it hovers the row also */
        background-color: #c8e6c9 !important;
    }

    #ag-grid-disregarded-alarms-container .ag-row-selected {
        background-color: #0000ff !important;
        color: #ffffff !important;
    }

</style>
